import ReactShape from './react-shape';
import { BaseNode } from '../../common';
import { CirclePort } from '../../node-port-class';
import { transformColorByPercent } from '../../../common';
export class RoundedRectangleNode extends BaseNode {
    get nodeStyle() {
        if (this.highlight) {
            return {
                borderColor: this.primaryColor,
                background: transformColorByPercent(this.primaryColor, 0.2)
            };
        }
        return {};
    }
    get nodePortsConfig() {
        const { id: parent, canvasModel } = this;
        const { direction } = canvasModel.rankConfig;
        return [{
                id: `${parent}-0`,
                parent,
                position: direction === 'vertical' ? 'top' : 'left',
                offset: 0.5,
                linkType: 'input',
            }, {
                id: `${parent}-1`,
                parent,
                position: direction === 'vertical' ? 'bottom' : 'right',
                offset: 0.5,
                linkType: 'output',
            }];
    }
    constructor(props) {
        super(props);
        this.NodePort = CirclePort;
        this.setNodePorts();
        this.setConfig((config) => {
            return Object.assign(Object.assign({}, RoundedRectangleNode.defaultConfig), config);
        });
    }
}
RoundedRectangleNode.ReactComponent = ReactShape;
RoundedRectangleNode.defaultConfig = {
    width: 130,
    height: 32,
};
//# sourceMappingURL=index.js.map